(function () {
  const STORAGE_KEY = 'theshogun_clicks_v1';
  const cfg = window.TheShogunClickAnalytics || {};
  const apiBase = (cfg.apiUrl || '').replace(/\/$/, '');

  function readLocal() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    } catch {
      return {};
    }
  }

  function writeLocal(map) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
    } catch {
      /* ignore quota */
    }
  }

  function productIdFromLink(link) {
    const card = link.closest('[data-product-id]');
    if (card?.dataset.productId) return String(card.dataset.productId);

    const match = link.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function trackClick(productId, handle) {
    if (!productId) return;

    const local = readLocal();
    local[productId] = (Number(local[productId]) || 0) + 1;
    writeLocal(local);

    document.dispatchEvent(
      new CustomEvent('theshogun:click-tracked', {
        detail: { productId, handle, count: local[productId] },
      })
    );

    if (window.Shopify?.analytics?.publish) {
      try {
        window.Shopify.analytics.publish('theshogun_product_click', {
          productId,
          handle: handle || '',
        });
      } catch {
        /* optional */
      }
    }

    if (!apiBase) return;

    const payload = JSON.stringify({
      productId,
      handle: handle || '',
      path: location.pathname,
    });

    const url = `${apiBase}/track`;
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([payload], { type: 'application/json' }));
      return;
    }

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true,
    }).catch(() => {});
  }

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a[href*="/products/"]');
      if (!link || link.target === '_blank') return;

      const card = link.closest('.product-grid__item, .trendyol-grid__card, [data-product-id]');
      if (!card && !link.pathname.includes('/products/')) return;

      const productId = productIdFromLink(link);
      const handleMatch = link.pathname.match(/\/products\/([^/?#]+)/);
      trackClick(productId, handleMatch ? handleMatch[1] : '');
    },
    { capture: true }
  );

  window.TheShogunClickAnalytics = {
    ...cfg,
    apiUrl: apiBase,
    getLocalCounts: readLocal,
  };
})();
